const MAX_DOM_DEPTH = 150;

export const limitHtmlDepth = (
  html: string,
  maxDepth: number = MAX_DOM_DEPTH
): string => {
  let depth = 0;
  return html.replace(/<\/?[a-zA-Z][^>]*>/g, (tag) => {
    if (tag[1] === '/') {
      if (depth > maxDepth) {
        depth--;
        return '';
      }
      depth--;
      return tag;
    }

    if (tag.endsWith('/>')) {
      return depth >= maxDepth ? '' : tag;
    }

    depth++;
    if (depth > maxDepth) {
      return '';
    }

    return tag;
  });
};
